import AjaxFormModal from './AjaxFormModal';
import CampingAjaxForm from '../forms/CampingAjaxForm';

class LoginModal extends AjaxFormModal {
  constructor(loginUrl) {
    super(loginUrl, CampingAjaxForm, { form_fields_container_selector: '#responseContainer' });
    this.contentHandlers = {
      forgotten_password_link: eventObject => {
        eventObject.preventDefault();
        this.swapModal(
          new AjaxFormModal(
            this.contentElements['forgotten_password_link'].getAttribute(
              'data-url',
            ),
            CampingAjaxForm,
            {
              form_fields_container_selector: '#modalResponseContainer',
            },
          ),
        );
      },
    };
  }

  setModalStyle() {
    this.elements.modal_window.classList.add('login-modal-temp');
  }

  unsetModalStyle() {
    this.elements.modal_window.classList.remove('login-modal-temp');
  }

  initContent() {
    super.initContent();
    this.contentElements[
      'forgotten_password_link'
    ] = this.elements.modal_content.querySelector('.js-modal-open');
    this.contentElements['forgotten_password_link'].addEventListener(
      'click',
      this.contentHandlers.forgotten_password_link,
    );
  }

  uninitContent() {
    super.uninitContent();
    this.contentElements['forgotten_password_link'].removeEventListener(
      'click',
      this.contentHandlers.forgotten_password_link,
    );
    this.contentElements = {};
  }
}

export default LoginModal;



// WEBPACK FOOTER //
// ./src/js/modals/LoginModal.js